import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { useI18n } from 'next-localization';
import { useMemo } from 'react';
import styles from './TrustCard.module.scss';

const TrustCard = ({ fields }) => {
  const { t } = useI18n();

  const link = useMemo(() => {
    if (!fields.trustLink) return false;
    return {
      value: {
        href: fields.trustLink.url,
        text: t('visitWebsite'),
        linktype: 'external',
        anchor: '',
        target: '_blank',
      },
    };
  }, [fields.trustLink, t]);

  return (
    <div className={`${styles['trust-card']} h-100`}>
      <div className={`${styles['trust-card__thumbnail']} flex-shrink-0`}>
        <NextImage field={fields.trustImage} alt={fields.trustImage.alt} width={270} height={270} />
      </div>
      <div
        className={`${styles['trust-card__body']} p-2 flex-grow-1 background-digital-light-grey`}
      >
        <div className="trust-card__heading d-flex align-items-start section-header-small">
          <span className="article-category section-header-small">
            {fields.trustRegion.targetItem.name.value}
          </span>
        </div>
        <div className="trust-card__content my-2">
          <h5 className="line-clamp-4">{fields.trustName.value}</h5>
          <p className="body-small text-grey line-clamp-3 mt-2">{fields.trustDescription.value}</p>
        </div>
        {link && (
          <div className="trust-card__footer mt-auto">
            <AbrdnButton linkField={link} buttonType="primary" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrustCard;
